import React from 'react';

import WsIconProps from './IconProps';

const MinusCircle: React.FC<WsIconProps> = ({ color = '#11151C', width = 20, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill={color}
    className="size-2"
  >
    <path
      fillRule="evenodd"
      d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm4-7a.75.75 0 0 0-.75-.75h-6.5a.75.75 0 0 0 0 1.5h6.5A.75.75 0 0 0 12 8Z"
      clipRule="evenodd"
    />
  </svg>
);

export default MinusCircle;
